import * as i0 from '@angular/core';
import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class EquisDividerComponent {
}
EquisDividerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDividerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisDividerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisDividerComponent, selector: "z-divider , equis-divider ", ngImport: i0, template: "<hr class=\"divider\" />\n", styles: [".divider{background-color:#e8e8e8;border:0;height:1px;margin:0}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDividerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-divider , equis-divider ', template: "<hr class=\"divider\" />\n", styles: [".divider{background-color:#e8e8e8;border:0;height:1px;margin:0}\n"] }]
        }] });

class EquisDividerModule {
    static forRoot() {
        return {
            ngModule: EquisDividerModule,
        };
    }
}
EquisDividerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDividerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisDividerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisDividerModule, declarations: [EquisDividerComponent], imports: [CommonModule], exports: [EquisDividerComponent] });
EquisDividerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDividerModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDividerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisDividerComponent],
                    imports: [CommonModule],
                    exports: [EquisDividerComponent],
                }]
        }] });

/*
 * Public API Surface of equis-divider
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EquisDividerComponent, EquisDividerModule };
